import Dashboard from "./components/Dashboard";
import History from "./history.json"
import { BrowserRouter as Router, Routes } from 'react-router-dom';

function App() {

  return (

    <div className="App ">
    <Router>
      <Routes exact path="src/history.json" component={History} />
    </Router>
      <Dashboard/>

    
    </div>
  );
}

export default App;
